"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedObjectCheckboxControl = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
exports.SharedObjectCheckboxControl = function (_a) {
    var isChecked = _a.isChecked, isSupported = _a.isSupported, onChange = _a.onChange, name = _a.name, label = _a.label, className = _a.className;
    if (!isSupported) {
        return null;
    }
    var handleOnChange = function (e) { return onChange(e.target.checked); };
    var classNames = classnames_1.default("input-checkbox-label", className);
    return (react_1.default.createElement("label", { className: classNames },
        react_1.default.createElement("input", { type: "checkbox", name: name, className: "input-checkbox", checked: isChecked, onChange: handleOnChange }),
        react_1.default.createElement("span", { className: "input-label-text" }, label)));
};
//# sourceMappingURL=SharedObjectCheckboxControl.js.map